import React, { useContext } from "react";
import { Radio } from "antd";

import Style from "../questionItem.module.scss";
import { RadioChangeEvent } from "antd/lib/radio";
import { previewExamContext } from "../../../context";
import { isTrue } from "../../../../../../service/service";

interface IProps {
    list: {
        answerId: number;
        content: string;
        isChoose: "0" | "1";
        isRight: "0" | "1";
    }[];
    homeworkState: number;
    onChange: (value: number) => void;
}

export const Single = ({ onChange, list, homeworkState }: IProps) => {
    const handleChange = (event: RadioChangeEvent) => {
        if (homeworkState === 2) return;
        onChange(event.target.value);
    };

    const { showAnswer } = useContext(previewExamContext);

    return (
        <Radio.Group onChange={handleChange}>
            {list.map(item => (
                <div key={item.answerId} className={Style.option}>
                    <Radio
                        className={
                            homeworkState === 2 && item.isRight === "1"
                                ? Style.success
                                : undefined
                        }
                        value={item.answerId}>
                        <div
                            className={Style.displayinlineblock}
                            dangerouslySetInnerHTML={{ __html: item.content }}
                        />
                        {showAnswer && isTrue(item.isRight) && (
                            <span className={Style.success}>正确答案</span>
                        )}
                    </Radio>
                </div>
            ))}
        </Radio.Group>
    );
};
